export interface Region {
  /** ISO 3166-2 code without the country prefix, as the backend stores it ("CA", "ON", "NSW"). */
  code: string;
  name: string;
}

/**
 * Regions for the countries jewelry stores split zones by (contiguous US vs Alaska and Hawaii,
 * Canadian provinces, EU-like splits inside Italy and Spain). Other countries ship whole.
 */
export const REGIONS: Readonly<Record<string, readonly Region[]>> = {
  US: [
    { code: 'AL', name: 'Alabama' },
    { code: 'AK', name: 'Alaska' },
    { code: 'AZ', name: 'Arizona' },
    { code: 'AR', name: 'Arkansas' },
    { code: 'CA', name: 'California' },
    { code: 'CO', name: 'Colorado' },
    { code: 'CT', name: 'Connecticut' },
    { code: 'DE', name: 'Delaware' },
    { code: 'DC', name: 'District of Columbia' },
    { code: 'FL', name: 'Florida' },
    { code: 'GA', name: 'Georgia' },
    { code: 'HI', name: 'Hawaii' },
    { code: 'ID', name: 'Idaho' },
    { code: 'IL', name: 'Illinois' },
    { code: 'IN', name: 'Indiana' },
    { code: 'IA', name: 'Iowa' },
    { code: 'KS', name: 'Kansas' },
    { code: 'KY', name: 'Kentucky' },
    { code: 'LA', name: 'Louisiana' },
    { code: 'ME', name: 'Maine' },
    { code: 'MD', name: 'Maryland' },
    { code: 'MA', name: 'Massachusetts' },
    { code: 'MI', name: 'Michigan' },
    { code: 'MN', name: 'Minnesota' },
    { code: 'MS', name: 'Mississippi' },
    { code: 'MO', name: 'Missouri' },
    { code: 'MT', name: 'Montana' },
    { code: 'NE', name: 'Nebraska' },
    { code: 'NV', name: 'Nevada' },
    { code: 'NH', name: 'New Hampshire' },
    { code: 'NJ', name: 'New Jersey' },
    { code: 'NM', name: 'New Mexico' },
    { code: 'NY', name: 'New York' },
    { code: 'NC', name: 'North Carolina' },
    { code: 'ND', name: 'North Dakota' },
    { code: 'OH', name: 'Ohio' },
    { code: 'OK', name: 'Oklahoma' },
    { code: 'OR', name: 'Oregon' },
    { code: 'PA', name: 'Pennsylvania' },
    { code: 'RI', name: 'Rhode Island' },
    { code: 'SC', name: 'South Carolina' },
    { code: 'SD', name: 'South Dakota' },
    { code: 'TN', name: 'Tennessee' },
    { code: 'TX', name: 'Texas' },
    { code: 'UT', name: 'Utah' },
    { code: 'VT', name: 'Vermont' },
    { code: 'VA', name: 'Virginia' },
    { code: 'WA', name: 'Washington' },
    { code: 'WV', name: 'West Virginia' },
    { code: 'WI', name: 'Wisconsin' },
    { code: 'WY', name: 'Wyoming' },
    { code: 'PR', name: 'Puerto Rico' },
    { code: 'GU', name: 'Guam' },
    { code: 'VI', name: 'U.S. Virgin Islands' },
  ],
  CA: [
    { code: 'AB', name: 'Alberta' },
    { code: 'BC', name: 'British Columbia' },
    { code: 'MB', name: 'Manitoba' },
    { code: 'NB', name: 'New Brunswick' },
    { code: 'NL', name: 'Newfoundland and Labrador' },
    { code: 'NS', name: 'Nova Scotia' },
    { code: 'NT', name: 'Northwest Territories' },
    { code: 'NU', name: 'Nunavut' },
    { code: 'ON', name: 'Ontario' },
    { code: 'PE', name: 'Prince Edward Island' },
    { code: 'QC', name: 'Quebec' },
    { code: 'SK', name: 'Saskatchewan' },
    { code: 'YT', name: 'Yukon' },
  ],
  AU: [
    { code: 'ACT', name: 'Australian Capital Territory' },
    { code: 'NSW', name: 'New South Wales' },
    { code: 'NT', name: 'Northern Territory' },
    { code: 'QLD', name: 'Queensland' },
    { code: 'SA', name: 'South Australia' },
    { code: 'TAS', name: 'Tasmania' },
    { code: 'VIC', name: 'Victoria' },
    { code: 'WA', name: 'Western Australia' },
  ],
  GB: [
    { code: 'ENG', name: 'England' },
    { code: 'NIR', name: 'Northern Ireland' },
    { code: 'SCT', name: 'Scotland' },
    { code: 'WLS', name: 'Wales' },
  ],
  IN: [
    { code: 'AN', name: 'Andaman and Nicobar Islands' },
    { code: 'AP', name: 'Andhra Pradesh' },
    { code: 'AR', name: 'Arunachal Pradesh' },
    { code: 'AS', name: 'Assam' },
    { code: 'BR', name: 'Bihar' },
    { code: 'CH', name: 'Chandigarh' },
    { code: 'CT', name: 'Chhattisgarh' },
    { code: 'DH', name: 'Dadra and Nagar Haveli and Daman and Diu' },
    { code: 'DL', name: 'Delhi' },
    { code: 'GA', name: 'Goa' },
    { code: 'GJ', name: 'Gujarat' },
    { code: 'HR', name: 'Haryana' },
    { code: 'HP', name: 'Himachal Pradesh' },
    { code: 'JK', name: 'Jammu and Kashmir' },
    { code: 'JH', name: 'Jharkhand' },
    { code: 'KA', name: 'Karnataka' },
    { code: 'KL', name: 'Kerala' },
    { code: 'LA', name: 'Ladakh' },
    { code: 'LD', name: 'Lakshadweep' },
    { code: 'MP', name: 'Madhya Pradesh' },
    { code: 'MH', name: 'Maharashtra' },
    { code: 'MN', name: 'Manipur' },
    { code: 'ML', name: 'Meghalaya' },
    { code: 'MZ', name: 'Mizoram' },
    { code: 'NL', name: 'Nagaland' },
    { code: 'OR', name: 'Odisha' },
    { code: 'PY', name: 'Puducherry' },
    { code: 'PB', name: 'Punjab' },
    { code: 'RJ', name: 'Rajasthan' },
    { code: 'SK', name: 'Sikkim' },
    { code: 'TN', name: 'Tamil Nadu' },
    { code: 'TG', name: 'Telangana' },
    { code: 'TR', name: 'Tripura' },
    { code: 'UP', name: 'Uttar Pradesh' },
    { code: 'UT', name: 'Uttarakhand' },
    { code: 'WB', name: 'West Bengal' },
  ],
  MX: [
    { code: 'AGU', name: 'Aguascalientes' },
    { code: 'BCN', name: 'Baja California' },
    { code: 'BCS', name: 'Baja California Sur' },
    { code: 'CAM', name: 'Campeche' },
    { code: 'CHP', name: 'Chiapas' },
    { code: 'CHH', name: 'Chihuahua' },
    { code: 'CMX', name: 'Ciudad de México' },
    { code: 'COA', name: 'Coahuila' },
    { code: 'COL', name: 'Colima' },
    { code: 'DUR', name: 'Durango' },
    { code: 'GUA', name: 'Guanajuato' },
    { code: 'GRO', name: 'Guerrero' },
    { code: 'HID', name: 'Hidalgo' },
    { code: 'JAL', name: 'Jalisco' },
    { code: 'MEX', name: 'Estado de México' },
    { code: 'MIC', name: 'Michoacán' },
    { code: 'MOR', name: 'Morelos' },
    { code: 'NAY', name: 'Nayarit' },
    { code: 'NLE', name: 'Nuevo León' },
    { code: 'OAX', name: 'Oaxaca' },
    { code: 'PUE', name: 'Puebla' },
    { code: 'QUE', name: 'Querétaro' },
    { code: 'ROO', name: 'Quintana Roo' },
    { code: 'SLP', name: 'San Luis Potosí' },
    { code: 'SIN', name: 'Sinaloa' },
    { code: 'SON', name: 'Sonora' },
    { code: 'TAB', name: 'Tabasco' },
    { code: 'TAM', name: 'Tamaulipas' },
    { code: 'TLA', name: 'Tlaxcala' },
    { code: 'VER', name: 'Veracruz' },
    { code: 'YUC', name: 'Yucatán' },
    { code: 'ZAC', name: 'Zacatecas' },
  ],
  BR: [
    { code: 'AC', name: 'Acre' },
    { code: 'AL', name: 'Alagoas' },
    { code: 'AP', name: 'Amapá' },
    { code: 'AM', name: 'Amazonas' },
    { code: 'BA', name: 'Bahia' },
    { code: 'CE', name: 'Ceará' },
    { code: 'DF', name: 'Distrito Federal' },
    { code: 'ES', name: 'Espírito Santo' },
    { code: 'GO', name: 'Goiás' },
    { code: 'MA', name: 'Maranhão' },
    { code: 'MT', name: 'Mato Grosso' },
    { code: 'MS', name: 'Mato Grosso do Sul' },
    { code: 'MG', name: 'Minas Gerais' },
    { code: 'PA', name: 'Pará' },
    { code: 'PB', name: 'Paraíba' },
    { code: 'PR', name: 'Paraná' },
    { code: 'PE', name: 'Pernambuco' },
    { code: 'PI', name: 'Piauí' },
    { code: 'RJ', name: 'Rio de Janeiro' },
    { code: 'RN', name: 'Rio Grande do Norte' },
    { code: 'RS', name: 'Rio Grande do Sul' },
    { code: 'RO', name: 'Rondônia' },
    { code: 'RR', name: 'Roraima' },
    { code: 'SC', name: 'Santa Catarina' },
    { code: 'SP', name: 'São Paulo' },
    { code: 'SE', name: 'Sergipe' },
    { code: 'TO', name: 'Tocantins' },
  ],
  IT: [
    { code: '65', name: 'Abruzzo' },
    { code: '77', name: 'Basilicata' },
    { code: '78', name: 'Calabria' },
    { code: '72', name: 'Campania' },
    { code: '45', name: 'Emilia-Romagna' },
    { code: '36', name: 'Friuli-Venezia Giulia' },
    { code: '62', name: 'Lazio' },
    { code: '42', name: 'Liguria' },
    { code: '25', name: 'Lombardia' },
    { code: '57', name: 'Marche' },
    { code: '67', name: 'Molise' },
    { code: '21', name: 'Piemonte' },
    { code: '75', name: 'Puglia' },
    { code: '88', name: 'Sardegna' },
    { code: '82', name: 'Sicilia' },
    { code: '52', name: 'Toscana' },
    { code: '32', name: 'Trentino-Alto Adige' },
    { code: '55', name: 'Umbria' },
    { code: '23', name: "Valle d'Aosta" },
    { code: '34', name: 'Veneto' },
  ],
  ES: [
    { code: 'AN', name: 'Andalucía' },
    { code: 'AR', name: 'Aragón' },
    { code: 'AS', name: 'Asturias' },
    { code: 'CN', name: 'Canarias' },
    { code: 'CB', name: 'Cantabria' },
    { code: 'CM', name: 'Castilla-La Mancha' },
    { code: 'CL', name: 'Castilla y León' },
    { code: 'CT', name: 'Catalunya' },
    { code: 'CE', name: 'Ceuta' },
    { code: 'EX', name: 'Extremadura' },
    { code: 'GA', name: 'Galicia' },
    { code: 'IB', name: 'Illes Balears' },
    { code: 'RI', name: 'La Rioja' },
    { code: 'MD', name: 'Madrid' },
    { code: 'ML', name: 'Melilla' },
    { code: 'MC', name: 'Murcia' },
    { code: 'NC', name: 'Navarra' },
    { code: 'PV', name: 'País Vasco' },
    { code: 'VC', name: 'Comunitat Valenciana' },
  ],
  JP: [
    { code: '01', name: 'Hokkaido' },
    { code: '02', name: 'Aomori' },
    { code: '03', name: 'Iwate' },
    { code: '04', name: 'Miyagi' },
    { code: '05', name: 'Akita' },
    { code: '06', name: 'Yamagata' },
    { code: '07', name: 'Fukushima' },
    { code: '08', name: 'Ibaraki' },
    { code: '09', name: 'Tochigi' },
    { code: '10', name: 'Gunma' },
    { code: '11', name: 'Saitama' },
    { code: '12', name: 'Chiba' },
    { code: '13', name: 'Tokyo' },
    { code: '14', name: 'Kanagawa' },
    { code: '15', name: 'Niigata' },
    { code: '16', name: 'Toyama' },
    { code: '17', name: 'Ishikawa' },
    { code: '18', name: 'Fukui' },
    { code: '19', name: 'Yamanashi' },
    { code: '20', name: 'Nagano' },
    { code: '21', name: 'Gifu' },
    { code: '22', name: 'Shizuoka' },
    { code: '23', name: 'Aichi' },
    { code: '24', name: 'Mie' },
    { code: '25', name: 'Shiga' },
    { code: '26', name: 'Kyoto' },
    { code: '27', name: 'Osaka' },
    { code: '28', name: 'Hyogo' },
    { code: '29', name: 'Nara' },
    { code: '30', name: 'Wakayama' },
    { code: '31', name: 'Tottori' },
    { code: '32', name: 'Shimane' },
    { code: '33', name: 'Okayama' },
    { code: '34', name: 'Hiroshima' },
    { code: '35', name: 'Yamaguchi' },
    { code: '36', name: 'Tokushima' },
    { code: '37', name: 'Kagawa' },
    { code: '38', name: 'Ehime' },
    { code: '39', name: 'Kochi' },
    { code: '40', name: 'Fukuoka' },
    { code: '41', name: 'Saga' },
    { code: '42', name: 'Nagasaki' },
    { code: '43', name: 'Kumamoto' },
    { code: '44', name: 'Oita' },
    { code: '45', name: 'Miyazaki' },
    { code: '46', name: 'Kagoshima' },
    { code: '47', name: 'Okinawa' },
  ],
};

export function regionsOf(countryCode: string): readonly Region[] {
  return REGIONS[countryCode] ?? [];
}

export function hasRegions(countryCode: string): boolean {
  return regionsOf(countryCode).length > 0;
}

export function regionName(countryCode: string, code: string): string {
  return regionsOf(countryCode).find((r) => r.code === code)?.name ?? code;
}
